const isDev = process.env.NODE_ENV === 'development';

const getSchoolUrl = school => {
  if (isDev) {
    // console.log('returning dev url', school)
    return '?school=' + school.uid;
  }
  // console.log('returning cms url')
  return `https://schoolinfrastructure.nsw.gov.au/school-lookup?school_code=${school.uid}`;
};

export default getSchoolUrl;



// WEBPACK FOOTER //
// ./src/modules/get-url.js